import type { LinkProps } from '@mui/material';
import { Link } from '@mui/material';
import type { ReactNode } from 'react';
import type { LegalDocumentDialogProps } from './legal-document-dialog';
import { LegalDocumentDialog } from './legal-document-dialog';
export type LegalDocumentLinkProps = {
  children: ReactNode;
  /** Whether the dialog is open; the app uses it to fetch the document on first open. */
  open: boolean;
  onOpenChange(open: boolean): void;
} & Omit<LegalDocumentDialogProps, 'open' | 'onClose'> & Pick<LinkProps, 'color' | 'variant' | 'underline'>;

/** Inline link that opens a legal document (terms, privacy policy) in a dialog. */
export function LegalDocumentLink({
  children,
  open,
  onOpenChange,
  color,
  variant,
  underline,
  ...dialogProps
}: LegalDocumentLinkProps) {
  return <>
      <Link component="button" type="button"
    // Link as a button is positioned by default, which would lift it above fixed toolbars.
    sx={{
      position: 'static',
      verticalAlign: 'baseline'
    }} color={color} variant={variant} underline={underline} onClick={() => onOpenChange(true)}>
        {children}
      </Link>
      <LegalDocumentDialog {...dialogProps} open={open} onClose={() => onOpenChange(false)} />
    </>;
}